import { Spin } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';

// layout needs to be imported as first component
// otherwise css order breaks
// https://github.com/gatsbyjs/gatsby/issues/9733#issuecomment-490132623
import { useFetchAccountOptions } from '../api/actions/useFetchAccountOptions';
import { useFetchInboxDictionary } from '../api/actions/useFetchInboxDictionary';
import { DevotionOfferingsContent } from '../components/DevotionOfferings/DevotionOfferingsContent/DevotionsOfferingsContent';
import DevotionOfferingsLayout from '../components/Layout/DevotionOfferingsLayout';
import selectors from '../store/selectors';
import { useFetchDevotionsDictionary } from '../api/actions/useFetchDevotionsDictionary';

const DevotionOfferings = () => {
  const isFetchingAccountOptions = useFetchAccountOptions();
  // const isDevotionOfferingsActive = useSelector(selectors.selectIsInboxMassOfferingsActive);
  const isDevotionOfferingsActive = true;
  const massOfferingAmount = useSelector(selectors.selectMassOfferingAmountOption);
  const { payload: inboxDictionary, loading: isFetchingInboxDictionary } =
    useFetchInboxDictionary();
  const { payload: devotionsDictionary, loading: isFetchingDevotionsDictionary } =
    useFetchDevotionsDictionary();

  let content = null;
  if (
    isFetchingAccountOptions ||
    isFetchingInboxDictionary ||
    isFetchingDevotionsDictionary ||
    massOfferingAmount === undefined
  ) {
    content = <Spin />;
  } else if (isDevotionOfferingsActive) {
    content = (
      <DevotionOfferingsContent
        inboxDictionary={inboxDictionary}
        devotionsDictionary={devotionsDictionary}
      />
    );
  } else {
    // content = <InboxMassOfferingsNotActive />;
    content = (
      <div>
        <p>Nie przyjmujemy obecnie intencji na nabożenśtwa poprzez formularz online.</p>
      </div>
    );
  }

  return <DevotionOfferingsLayout>{content}</DevotionOfferingsLayout>;
};

export default DevotionOfferings;
